export const genres = [
  { name: '动作', icon: 'ri-sword-line', desc: '追逐、爆破与硬核打斗' },
  { name: '科幻', icon: 'ri-rocket-2-line', desc: '未来世界与宇宙想象' },
  { name: '爱情', icon: 'ri-heart-3-line', desc: '心动、错过与重逢' },
  { name: '喜剧', icon: 'ri-emotion-laugh-line', desc: '一整晚的轻松大笑' },
  { name: '剧情', icon: 'ri-book-open-line', desc: '关于人的真实切片' },
  { name: '悬疑', icon: 'ri-search-eye-line', desc: '线索、反转与真相' },
  { name: '犯罪', icon: 'ri-police-car-line', desc: '罪案背后的灰色地带' },
  { name: '家庭', icon: 'ri-home-heart-line', desc: '关于家与牵挂的故事' },
];

export const regionOptions = ['全部地区', '中国大陆', '中国香港', '中国台湾', '美国', '日本', '韩国', '法国', '英国'];
export const yearOptions = ['全部年份', '2026', '2025', '2024', '2023', '2022', '2021'];
export const ratingOptions = [
  { label: '全部评分', value: 0 },
  { label: '9.0 分以上', value: 9 },
  { label: '8.0 分以上', value: 8 },
  { label: '7.5 分以上', value: 7.5 },
];

export const movies = [
  {
    id: 'chasing-the-dark',
    title: '暗夜追光',
    enTitle: 'CHASING THE DARK',
    tagline: '在城市熄灯之后，仍有人替我们奔跑',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20art%2C%20lone%20figure%20in%20a%20long%20coat%20walking%20down%20a%20rain-soaked%20neon%20alley%20at%20midnight%2C%20deep%20teal%20shadows%20with%20amber%20streetlight%20glow%2C%20dramatic%20low%20key%20lighting%2C%20wet%20asphalt%20reflections%2C%20moody%20atmospheric%20film%20grain%2C%20no%20text%2C%20editorial%20cinema%20poster%20composition&width=600&height=900&seq=midnight-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20city%20street%20at%20night%20in%20heavy%20rain%2C%20lone%20silhouette%20running%20through%20neon%20reflections%2C%20deep%20midnight%20blue%20and%20warm%20amber%20contrast%2C%20volumetric%20light%20beams%2C%20anamorphic%20lens%20flare%2C%20moody%20crime%20film%20still%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-back-01&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    duration: 128,
    genres: ['动作', '犯罪', '悬疑'],
    rating: 8.7,
    popularity: 98,
    director: '程砚秋',
    cast: ['林昭', '沈砚', '周晚棠', '赵一鸣'],
    releaseDate: '2026-09-26',
    synopsis: '一名被停职的刑警在午夜接到匿名电话，电话那头的人声称自己将在天亮前杀死四个人。为了阻止这场倒计时，他必须重新走进自己曾经逃离的旧城区，在霓虹与雨水之间，找回那段被刻意掩埋的真相。',
    featured: true,
    tags: ['高能反转', '港味夜戏', '孤胆追凶'],
  },
  {
    id: 'echoes-of-the-void',
    title: '星际回声',
    enTitle: 'ECHOES OF THE VOID',
    tagline: '我们听见的，也许是二十年前的自己',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20poster%2C%20astronaut%20silhouette%20standing%20before%20an%20immense%20glowing%20ringed%20planet%2C%20cold%20deep%20blue%20space%20with%20orange%20nebula%20accent%2C%20soft%20volumetric%20starlight%2C%20minimal%20composition%2C%20cinematic%20anamorphic%20look%2C%20fine%20film%20grain%2C%20no%20text&width=600&height=900&seq=midnight-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Vast%20space%20scene%20with%20a%20gigantic%20ringed%20planet%20rising%20behind%20a%20small%20spacecraft%2C%20deep%20navy%20nebula%20clouds%20with%20embers%20of%20orange%20light%2C%20lens%20flare%2C%20ultra%20wide%20cinematic%20composition%2C%20atmospheric%20sci-fi%20film%20still%2C%20no%20text&width=1600&height=900&seq=midnight-back-02&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    duration: 146,
    genres: ['科幻', '剧情', '冒险'],
    rating: 9.1,
    popularity: 95,
    director: '陆知远',
    cast: ['顾南舟', '苏念', '许清和'],
    releaseDate: '2026-08-14',
    synopsis: '深空监听站的值班员捕捉到一段来自太阳系边缘的重复信号，而信号内容竟是她童年时录下的一段摇篮曲。随着解码深入，她意识到这不是外星文明的问候，而是一场跨越二十年的告别。',
    featured: true,
    tags: ['硬科幻', '太空孤独', '年度神作'],
  },
  {
    id: 'neon-labyrinth',
    title: '霓虹迷城',
    enTitle: 'NEON LABYRINTH',
    tagline: '记忆可以买卖，真相不能退货',
    poster: 'https://readdy.ai/api/search-image?query=Cyberpunk%20neo-noir%20movie%20poster%2C%20woman%20with%20short%20hair%20seen%20through%20rain-covered%20glass%2C%20saturated%20magenta%20and%20orange%20neon%20signage%20reflections%2C%20dark%20midnight%20blue%20shadows%2C%20dense%20futuristic%20cityscape%20bokeh%2C%20mysterious%20mood%2C%20cinematic%20film%20grain%2C%20no%20text&width=600&height=900&seq=midnight-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Futuristic%20Asian%20megacity%20at%20night%20seen%20from%20a%20rooftop%2C%20layers%20of%20neon%20signs%20in%20orange%20and%20warm%20red%2C%20deep%20navy%20sky%2C%20holographic%20billboards%2C%20rain%20haze%2C%20cinematic%20wide%20shot%2C%20neo-noir%20atmosphere%2C%20no%20text&width=1600&height=900&seq=midnight-back-03&orientation=landscape',
    year: 2026,
    region: '中国香港',
    duration: 121,
    genres: ['科幻', '悬疑', '犯罪'],
    rating: 8.3,
    popularity: 91,
    director: '麦子谦',
    cast: ['何未', '黎嘉言', '方澄'],
    releaseDate: '2026-07-03',
    synopsis: '在不远的未来，记忆可以被提取、剪辑、出售。一名专门替人“清洗”记忆的技术员，在一位女顾客的脑海里发现了自己的脸。为了弄清自己究竟是谁，他走进这座城市最深的一条霓虹巷道。',
    featured: true,
    tags: ['赛博朋克', '记忆迷宫', '港式美学'],
  },
  {
    id: 'between-mountains-and-sea',
    title: '山海之间',
    enTitle: 'BETWEEN MOUNTAINS AND SEA',
    tagline: '回家的路，走了整整十年',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20literary%20drama%20film%20poster%2C%20young%20couple%20standing%20on%20a%20misty%20coastal%20cliff%20road%20at%20dusk%2C%20soft%20amber%20sunset%20light%20against%20deep%20blue%20sea%20and%20mountains%2C%20gentle%20melancholic%20mood%2C%20fine%20grain%2C%20minimal%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Winding%20mountain%20road%20along%20the%20sea%20at%20golden%20hour%2C%20fishing%20village%20in%20the%20distance%2C%20warm%20orange%20sunlight%20and%20cool%20navy%20shadows%2C%20mist%20over%20the%20water%2C%20cinematic%20wide%20landscape%20shot%2C%20nostalgic%20film%20look%2C%20no%20text&width=1600&height=900&seq=midnight-back-04&orientation=landscape',
    year: 2024,
    region: '中国台湾',
    duration: 132,
    genres: ['剧情', '爱情', '家庭'],
    rating: 8.9,
    popularity: 84,
    director: '陈以文',
    cast: ['许光', '林雨青', '吴念真'],
    releaseDate: '2024-11-08',
    synopsis: '一封迟到十年的信，把两个早已走散的人重新叫回海边的小镇。母亲的葬礼、老屋的钥匙、以及一间快要关门的电影院，让他们不得不重新面对当年那个谁都不肯先低头的夜晚。',
    featured: false,
    tags: ['温柔治愈', '海边小镇', '口碑佳作'],
  },
  {
    id: 'laughing-changan',
    title: '笑忘长安',
    enTitle: 'LAUGHING IN CHANG\'AN',
    tagline: '一个假道士，半座长安城的麻烦',
    poster: 'https://readdy.ai/api/search-image?query=Playful%20Chinese%20period%20comedy%20movie%20poster%2C%20wandering%20trickster%20in%20colorful%20tang%20dynasty%20robes%20holding%20a%20paper%20fan%2C%20lantern-lit%20ancient%20street%20at%20night%2C%20rich%20amber%20and%20deep%20red%20tones%20with%20navy%20shadows%2C%20theatrical%20lighting%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Bustling%20ancient%20Chinese%20capital%20street%20at%20night%20filled%20with%20red%20lanterns%2C%20acrobats%20and%20merchants%2C%20warm%20golden%20light%20against%20deep%20blue%20sky%2C%20festive%20chaotic%20energy%2C%20cinematic%20period%20comedy%20still%2C%20no%20text&width=1600&height=900&seq=midnight-back-05&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    duration: 115,
    genres: ['喜剧', '古装'],
    rating: 7.8,
    popularity: 88,
    director: '高临',
    cast: ['岳川', '白小满', '任九'],
    releaseDate: '2024-02-10',
    synopsis: '长安城里最不像道士的道士，靠一张嘴混了十年饭吃。直到某天，他随口编出的“天降大祸”真的应验了，全城的权贵与骗子同时找上门来，他只能硬着头皮，把这场骗局演成一场救赎。',
    featured: false,
    tags: ['春节档', '古装喜剧', '群像笑料'],
  },
  {
    id: 'letters-in-the-rain',
    title: '雨巷来信',
    enTitle: 'LETTERS IN THE RAIN',
    tagline: '有些话，只适合在雨里说',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20art-house%20film%20poster%2C%20young%20woman%20holding%20an%20umbrella%20in%20a%20narrow%20old%20alley%20during%20rain%2C%20soft%20desaturated%20green%20and%20warm%20paper%20tones%2C%20glowing%20window%20light%2C%20delicate%20melancholic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=midnight-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20old%20southern%20Chinese%20alley%20with%20wet%20stone%20paving%2C%20single%20umbrella%2C%20warm%20lamp%20glow%20from%20wooden%20windows%2C%20soft%20mist%2C%20deep%20green%20and%20amber%20tones%2C%20poetic%20cinematic%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-back-06&orientation=landscape',
    year: 2022,
    region: '中国大陆',
    duration: 104,
    genres: ['爱情', '剧情'],
    rating: 8.5,
    popularity: 72,
    director: '苏禾',
    cast: ['周迟', '沈知微'],
    releaseDate: '2022-06-18',
    synopsis: '一家即将拆迁的旧邮局，一位替人代写书信的老人，和一个每周三准时来取信的姑娘。三年里，她从未见过写信的人，却在那叠潮湿的信纸里，爱上了一个不存在的人。',
    featured: false,
    tags: ['文艺片', '书信', '雨中氛围'],
  },
  {
    id: 'abyss-express',
    title: '深海列车',
    enTitle: 'THE ABYSS EXPRESS',
    tagline: '终点站没有站台',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20long%20empty%20subway%20carriage%20flooded%20with%20dim%20blue%20light%2C%20single%20passenger%20silhouette%20at%20the%20far%20end%2C%20water%20dripping%20from%20ceiling%2C%20deep%20dark%20teal%20and%20rust%20orange%20accents%2C%20claustrophobic%20atmosphere%2C%20cinematic%20horror%20still%2C%20no%20text&width=600&height=900&seq=midnight-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ghostly%20abandoned%20underground%20train%20tunnel%20filled%20with%20shallow%20water%2C%20a%20single%20lit%20carriage%20in%20the%20distance%2C%20cold%20navy%20shadows%20with%20faint%20orange%20emergency%20lights%2C%20dense%20fog%2C%20eerie%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=midnight-back-07&orientation=landscape',
    year: 2025,
    region: '韩国',
    duration: 118,
    genres: ['悬疑', '惊悚'],
    rating: 8.1,
    popularity: 86,
    director: '朴贤洙',
    cast: ['金泰河', '尹素拉', '崔民在'],
    releaseDate: '2025-10-31',
    synopsis: '末班地铁在隧道中停了十七分钟，车厢里的七名乘客发现，窗外不是隧道，而是一片看不到底的海。每到一站，就会有一节车厢被水吞没，而列车广播始终在提醒：请坐稳，下一站，回忆。',
    featured: false,
    tags: ['密闭空间', '海底恐惧', '午夜档'],
  },
  {
    id: 'the-last-snow',
    title: '最后一场雪',
    enTitle: 'THE LAST SNOW',
    tagline: '冬天会走，人会留下',
    poster: 'https://readdy.ai/api/search-image?query=Gentle%20family%20drama%20movie%20poster%2C%20elderly%20man%20and%20a%20young%20girl%20walking%20along%20a%20snow-covered%20village%20road%2C%20warm%20window%20light%20in%20the%20distance%2C%20soft%20blue%20snow%20and%20amber%20accents%2C%20quiet%20emotional%20atmosphere%2C%20cinematic%20natural%20light%2C%20no%20text&width=600&height=900&seq=midnight-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Snowy%20northern%20Chinese%20village%20at%20dusk%2C%20smoke%20rising%20from%20chimneys%2C%20warm%20orange%20window%20glow%20across%20blue%20snow%20fields%2C%20single%20footprints%20trail%2C%20peaceful%20melancholic%20cinematic%20landscape%2C%20no%20text&width=1600&height=900&seq=midnight-back-08&orientation=landscape',
    year: 2023,
    region: '中国大陆',
    duration: 126,
    genres: ['剧情', '家庭'],
    rating: 9.0,
    popularity: 79,
    director: '梁守一',
    cast: ['李海生', '杜若', '孙冬'],
    releaseDate: '2023-12-22',
    synopsis: '老人在妻子离开后的第一个冬天，决定独自把孙女从城里接回老家过年。一路上，他反复讲着同一个故事，而孙女直到雪停才明白，那个故事里的主角，其实一直是他自己。',
    featured: false,
    tags: ['催泪', '东北冬天', '亲情'],
  },
  {
    id: 'dragon-ridge',
    title: '龙脊',
    enTitle: 'DRAGON RIDGE',
    tagline: '山不会让路，人可以让命',
    poster: 'https://readdy.ai/api/search-image?query=Martial%20arts%20epic%20movie%20poster%2C%20lone%20swordsman%20standing%20on%20a%20rocky%20mountain%20ridge%20in%20mist%2C%20flowing%20dark%20robe%2C%20dramatic%20golden%20sunrise%20rim%20light%20against%20deep%20navy%20clouds%2C%20epic%20scale%2C%20cinematic%20wuxia%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20misty%20mountain%20ridges%20at%20dawn%2C%20tiny%20figure%20with%20a%20sword%20on%20a%20cliff%20path%2C%20layers%20of%20blue%20mountains%20and%20warm%20orange%20sunlight%2C%20drifting%20clouds%2C%20sweeping%20cinematic%20wuxia%20landscape%2C%20no%20text&width=1600&height=900&seq=midnight-back-09&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    duration: 138,
    genres: ['动作', '武侠', '剧情'],
    rating: 8.4,
    popularity: 90,
    director: '徐北',
    cast: ['谢无咎', '柳青', '韩朴'],
    releaseDate: '2024-04-19',
    synopsis: '三十年前，龙脊山上的一场雪崩埋掉了半个门派。三十年后，唯一活下来的杂役弟子带着一把断剑回到山上，只为问一句：当年那把推人下山的手，究竟属于谁。',
    featured: false,
    tags: ['新派武侠', '实景拍摄', '复仇'],
  },
  {
    id: 'time-mender',
    title: '时空修补匠',
    enTitle: 'THE TIME MENDER',
    tagline: '修得好钟表，修不好遗憾',
    poster: 'https://readdy.ai/api/search-image?query=Thoughtful%20sci-fi%20drama%20movie%20poster%2C%20watchmaker%20examining%20a%20glowing%20broken%20pocket%20watch%2C%20workshop%20filled%20with%20hundreds%20of%20clocks%2C%20warm%20amber%20light%20against%20deep%20blue%20shadows%2C%20floating%20dust%20particles%2C%20intimate%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cluttered%20old%20watchmaker%20workshop%20at%20night%2C%20hundreds%20of%20glowing%20clocks%20on%20walls%2C%20warm%20amber%20lamplight%20with%20cool%20blue%20window%20light%2C%20magical%20realism%20atmosphere%2C%20cinematic%20interior%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=midnight-back-10&orientation=landscape',
    year: 2023,
    region: '日本',
    duration: 120,
    genres: ['科幻', '剧情', '奇幻'],
    rating: 8.8,
    popularity: 81,
    director: '小野寺圭',
    cast: ['佐藤亮', '宫原理沙', '高木修'],
    releaseDate: '2023-09-15',
    synopsis: '街角的钟表店有一项不写在招牌上的服务：只要带来一件与遗憾有关的旧物，店主就能把它修回某个特定的时刻。但每位客人只能修一次，而店主自己，已经等了一百年。',
    featured: false,
    tags: ['治愈系', '时间回溯', '温柔'],
  },
  {
    id: 'silent-testimony',
    title: '沉默证词',
    enTitle: 'SILENT TESTIMONY',
    tagline: '唯一的证人，不会说话',
    poster: 'https://readdy.ai/api/search-image?query=Legal%20crime%20thriller%20poster%2C%20female%20lawyer%20in%20a%20dark%20courtroom%20holding%20a%20case%20file%2C%20harsh%20shaft%20of%20white%20light%20cutting%20through%20deep%20navy%20shadows%2C%20muted%20orange%20accent%2C%20tense%20serious%20mood%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Empty%20old%20courthouse%20corridor%20at%20night%2C%20rain-streaked%20windows%2C%20single%20lit%20doorway%20at%20the%20end%2C%20cold%20navy%20tones%20with%20warm%20amber%20light%2C%20long%20shadows%2C%20tense%20cinematic%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-back-11&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    duration: 124,
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.6,
    popularity: 93,
    director: '沈拾',
    cast: ['温琳', '程野', '邵川'],
    releaseDate: '2026-05-22',
    synopsis: '一桩看似证据确凿的凶杀案，唯一的目击者是一名失聪的清洁工。年轻律师接手案件后才发现，所有人口中的“事实”都过于整齐，而唯一不会说谎的人，正在被所有人忽略。',
    featured: false,
    tags: ['法庭辩论', '社会派', '演技派'],
  },
  {
    id: 'summer-cinema',
    title: '夏日放映厅',
    enTitle: 'SUMMER CINEMA',
    tagline: '那年夏天，电影散场了我们还没走',
    poster: 'https://readdy.ai/api/search-image?query=Nostalgic%20youth%20romance%20film%20poster%2C%20two%20teenagers%20sitting%20in%20an%20old%20small-town%20cinema%20watching%20a%20projector%20beam%2C%20summer%20heat%20haze%2C%20warm%20golden%20and%20faded%20teal%20tones%2C%20soft%20dreamy%20nostalgia%2C%20film%20grain%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Old%20small-town%20cinema%20exterior%20on%20a%20hot%20summer%20evening%2C%20glowing%20marquee%20and%20paper%20posters%2C%20bicycles%20parked%20outside%2C%20warm%20orange%20sunset%20with%20dust%20in%20the%20air%2C%20nostalgic%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=midnight-back-12&orientation=landscape',
    year: 2024,
    region: '中国台湾',
    duration: 108,
    genres: ['青春', '爱情', '剧情'],
    rating: 7.9,
    popularity: 75,
    director: '林彦廷',
    cast: ['陈屿', '简宁', '黄书维'],
    releaseDate: '2024-07-12',
    synopsis: '1999年的夏天，镇上唯一一家影院即将关门。两个准备离家去大城市的高中生约定，在影院关门前看完最后一百部电影。他们以为在告别的是电影，其实是在告别彼此。',
    featured: false,
    tags: ['青春怀旧', '夏日', '初恋'],
  },
  {
    id: 'wasteland-courier',
    title: '荒原信使',
    enTitle: 'COURIER OF THE WASTELAND',
    tagline: '没有信号的地方，只能靠人跑',
    poster: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20action%20movie%20poster%2C%20lone%20courier%20with%20a%20weathered%20backpack%20and%20goggles%20crossing%20a%20sand-buried%20highway%2C%20ruined%20city%20skyline%2C%20dust%20storm%2C%20deep%20rust%20orange%20and%20charcoal%20blue%20tones%2C%20epic%20gritty%20cinematic%20look%2C%20no%20text&width=600&height=900&seq=midnight-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Endless%20desert%20wasteland%20with%20a%20buried%20highway%20and%20abandoned%20cars%2C%20lone%20figure%20walking%20toward%20a%20distant%20ruined%20city%2C%20sandstorm%20on%20the%20horizon%2C%20warm%20orange%20dust%20and%20cold%20blue%20sky%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=midnight-back-13&orientation=landscape',
    year: 2022,
    region: '美国',
    duration: 131,
    genres: ['科幻', '动作', '冒险'],
    rating: 7.6,
    popularity: 68,
    director: 'Ethan Cole',
    cast: ['Mara Vance', 'Dorian Reyes'],
    releaseDate: '2022-08-05',
    synopsis: '在通讯彻底瘫痪的第四年，一名跑单的信使接到最后一份委托：把一枚硬盘送到两千公里外的避难所。硬盘里存着什么没人知道，但所有想抢它的人，都已经上路了。',
    featured: false,
    tags: ['末世公路', '硬核动作', '废土美学'],
  },
  {
    id: 'fathers-film',
    title: '父亲的胶片',
    enTitle: 'MY FATHER\'S FILM',
    tagline: '他把一生剪进了三十分钟',
    poster: 'https://readdy.ai/api/search-image?query=Intimate%20family%20drama%20poster%2C%20hands%20holding%20a%20strip%20of%2035mm%20film%20against%20warm%20projector%20light%2C%20dust%20and%20scratches%20visible%2C%20deep%20amber%20glow%20with%20dark%20navy%20background%2C%20quiet%20emotional%20atmosphere%2C%20macrophotography%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=midnight-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Old%20film%20editing%20room%20with%20a%20projector%20casting%20warm%20light%20through%20dust%2C%20reels%20and%20canisters%20on%20wooden%20shelves%2C%20nostalgic%20amber%20tones%20against%20deep%20blue%20shadows%2C%20cinematic%20interior%2C%20no%20text&width=1600&height=900&seq=midnight-back-14&orientation=landscape',
    year: 2021,
    region: '中国大陆',
    duration: 112,
    genres: ['剧情', '家庭'],
    rating: 9.2,
    popularity: 85,
    director: '田川',
    cast: ['刘敬之', '宋宁', '田小满'],
    releaseDate: '2021-10-15',
    synopsis: '父亲去世后，儿子在阁楼里找到一箱从未冲洗的胶片。送去修复后他才发现，那是一部拍了三十年的家庭电影，而镜头里的自己，从出生一直长大到父亲再也举不动摄影机的那天。',
    featured: false,
    tags: ['年度催泪', '胶片记忆', '父与子'],
  },
  {
    id: 'city-against-current',
    title: '逆流之城',
    enTitle: 'CITY AGAINST THE CURRENT',
    tagline: '所有人都在往前走，只有他往回游',
    poster: 'https://readdy.ai/api/search-image?query=Social%20realist%20drama%20movie%20poster%2C%20middle-aged%20man%20standing%20on%20a%20crowded%20city%20overpass%20at%20dusk%2C%20motion-blurred%20commuters%20around%20him%2C%20cold%20grey-blue%20tone%20with%20a%20single%20warm%20orange%20sign%2C%20isolated%20mood%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20modern%20Chinese%20city%20overpass%20at%20rush%20hour%2C%20streams%20of%20blurred%20traffic%20light%20trails%2C%20one%20still%20figure%20overlooking%20the%20city%2C%20cold%20blue%20tones%20with%20orange%20streetlights%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=midnight-back-15&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    duration: 119,
    genres: ['剧情', '社会'],
    rating: 8.2,
    popularity: 73,
    director: '郑野',
    cast: ['白宇宁', '梁秋', '许一鸣'],
    releaseDate: '2024-09-20',
    synopsis: '一名在互联网公司工作了十五年的中层，在四十岁生日那天被裁员。他决定瞒着家人，每天照常出门，在城市的各个角落假装上班，直到有一天，他在公园里遇见了同样在假装退休的父亲。',
    featured: false,
    tags: ['现实题材', '中年困境', '都市'],
  },
  {
    id: 'polar-day',
    title: '极昼计划',
    enTitle: 'PROJECT POLAR DAY',
    tagline: '太阳不落山，有人就永远醒着',
    poster: 'https://readdy.ai/api/search-image?query=Arctic%20sci-fi%20thriller%20poster%2C%20figure%20in%20a%20heavy%20parka%20standing%20beside%20a%20huge%20abandoned%20research%20dome%20in%20polar%20daylight%2C%20endless%20ice%2C%20pale%20cold%20blue%20light%20with%20a%20distant%20orange%20warning%20flare%2C%20eerie%20isolation%2C%20cinematic%20wide%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Vast%20arctic%20ice%20field%20under%20midnight%20sun%2C%20abandoned%20scientific%20research%20facility%20silhouette%2C%20cold%20pale%20blue%20light%20with%20warm%20orange%20flares%2C%20thick%20fog%20and%20snow%20drift%2C%20cinematic%20isolation%20atmosphere%2C%20no%20text&width=1600&height=900&seq=midnight-back-16&orientation=landscape',
    year: 2026,
    region: '法国',
    duration: 117,
    genres: ['科幻', '惊悚', '悬疑'],
    rating: 8.0,
    popularity: 77,
    director: 'ClaireMoreau',
    cast: ['Léa Bernard', 'Mathis Roux'],
    releaseDate: '2026-03-13',
    synopsis: '北极圈内的一座科研站，在极昼开始的第七天与外界失去联系。救援队抵达时，站内一切正常，只是所有人都坚持说：现在是晚上，请不要开灯。',
    featured: false,
    tags: ['极地惊悚', '心理压迫', '高概念'],
  },
  {
    id: 'comedy-king-returns',
    title: '喜剧之王归来',
    enTitle: 'RETURN OF THE COMEDY KING',
    tagline: '让人笑，是一件很严肃的事',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20showbiz%20comedy%20movie%20poster%2C%20aging%20stand-up%20comedian%20alone%20on%20a%20small%20club%20stage%20under%20a%20single%20spotlight%2C%20empty%20chairs%2C%20warm%20amber%20light%20against%20deep%20navy%20shadows%2C%20bittersweet%20mood%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-17&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Empty%20old%20comedy%20club%20with%20red%20stage%20curtains%20and%20a%20single%20microphone%20in%20warm%20spotlight%2C%20rows%20of%20vacant%20chairs%2C%20dusty%20stage%2C%20bittersweet%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=midnight-back-17&orientation=landscape',
    year: 2023,
    region: '中国香港',
    duration: 110,
    genres: ['喜剧', '剧情'],
    rating: 7.4,
    popularity: 66,
    director: '冯子澄',
    cast: ['陈百祥', '吴嘉谊', '何乐'],
    releaseDate: '2023-06-30',
    synopsis: '曾经红极一时的喜剧演员，如今只能在小酒吧演出。当主办方要求他重演二十年前的经典桥段时，他第一次在台上说了真话，而那一晚，台下只有六个人。',
    featured: false,
    tags: ['小人物', '笑中带泪', '港片'],
  },
  {
    id: 'a-second-of-eternity',
    title: '一秒钟的永恒',
    enTitle: 'A SECOND OF ETERNITY',
    tagline: '我把时间停住，只为多看你一眼',
    poster: 'https://readdy.ai/api/search-image?query=Poetic%20fantasy%20romance%20movie%20poster%2C%20couple%20frozen%20in%20mid-motion%20on%20a%20busy%20city%20street%20as%20raindrops%20hang%20suspended%20in%20the%20air%2C%20warm%20amber%20light%20and%20deep%20blue%20shadows%2C%20surreal%20dreamlike%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=midnight-poster-18&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Surreal%20city%20street%20at%20night%20where%20time%20is%20frozen%2C%20suspended%20raindrops%20and%20still%20crowds%2C%20one%20person%20walking%20freely%20through%20the%20scene%2C%20warm%20orange%20lamps%20and%20cool%20navy%20sky%2C%20dreamlike%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=midnight-back-18&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    duration: 106,
    genres: ['爱情', '奇幻'],
    rating: 8.5,
    popularity: 89,
    director: '叶知秋',
    cast: ['尹夏', '顾清川', '林一'],
    releaseDate: '2026-02-13',
    synopsis: '一个只能在时间静止时活动的男人，在某个凌晨遇见了一个同样不受影响的女人。他们拥有整座空无一人的城市，却只有一秒钟，因为下一秒，世界就会重新开始运转。',
    featured: true,
    tags: ['情人节档', '时间暂停', '浪漫奇幻'],
  },
];

